import { ReactElement, useMemo } from "react";

import {
  criticalDisabledFlyoutMenuLeft,
  criticalFlyoutMenuLeft,
  defaultDisabledFlyoutMenuLeft,
  flyoutMenuItem,
  flyoutMenuItemContainer,
  flyoutMenuItemDisabled,
  flyoutMenuItemHover,
  flyoutMenuItemLeft,
  rightSvgContainer,
} from "chameleon/lib/components/flyout/flyout.css";

export interface FlyoutItemProps {
  /**
   * Left SVG
   */
  leftSvg?: ReactElement;
  /**
   * Right SVG
   */
  rightSvg?: ReactElement;
  /**
   * Text
   */
  text: string;
  /**
   * OnClick
   */
  onClick: () => void;
  /**
   *    * Variant - default | text
   */
  variant?: "default" | "critical";
  /**
   * isDisabled
   */
  isDisabled?: boolean;
  /**
   * Test id will be applied if added
   */
  testId?: string;
}

export const MenuItem = ({
  leftSvg,
  rightSvg,
  text,
  onClick,
  variant = "default",
  isDisabled = false,
  testId,
}: FlyoutItemProps) => {
  const variantStyle = useMemo(() => {
    switch (variant) {
      case "critical":
        return `${criticalFlyoutMenuLeft} ${isDisabled ? criticalDisabledFlyoutMenuLeft : ""}`;
      default:
        return `${isDisabled ? defaultDisabledFlyoutMenuLeft : ""}`;
    }
  }, [variant, isDisabled]);
  return (
    <div className={flyoutMenuItemContainer}>
      <button
        onClick={onClick}
        className={`${flyoutMenuItem} ${!isDisabled && flyoutMenuItemHover} ${isDisabled && flyoutMenuItemDisabled}`}
        disabled={isDisabled}
        data-testid={testId}
      >
        <div className={`${flyoutMenuItemLeft} ${variantStyle}`}>
          <span role="presentation" aria-hidden={"true"}>
            {leftSvg}
          </span>
          <span>{text}</span>
        </div>
      </button>
      {rightSvg && <div className={rightSvgContainer}>{rightSvg}</div>}
    </div>
  );
};
